let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("avLBo")).then(() => parcelRequire('cf74N'));